import { UseMultipleChartsType } from '@ecosystem/export-utils';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export interface ExportContextType {
  /**
   * Use this variable to keep track of the initialisation status of each chart, which is useful
   * to determine whether we can proceed to export the chart(s).
   */
  chartRefsIsInitialisedStatus: boolean[];

  setChartRefsIsInitialisedStatus: Dispatch<SetStateAction<boolean[]>>;

  multipleExportCallbacks: UseMultipleChartsType;

  setMultipleExportCallbacks: Dispatch<SetStateAction<UseMultipleChartsType>>;
}

export const ExportContext = createContext<ExportContextType>({} as ExportContextType);

export const useExportContext = (): ExportContextType =>
  useContext<ExportContextType>(ExportContext);
